/* TODO они общие из UI, мб вынести куда? */
export const DEFAULT = 'default';
export const ERROR = 'error';
export const PROCESSING = 'processing';
export const SUCCESS = 'success';
export const WARNING = 'warning';
